// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image___ccCg","animate":"Image_animate__AW2Ju","svg":"Image_svg__N4s4s"};